var UTIL = (function(UTIL, $, window, document, undefined){

  // CSS 100svh / 100lvh in px. Cached by innerWidth so iOS URL-bar show/hide
  // does not change values (window.innerHeight does).
  var viewportUnitCache = {
    svh: { px: 0, width: -1 },
    lvh: { px: 0, width: -1 }
  };

  function measureViewportUnitPx(unit){
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;top:0;left:0;height:100' + unit + ';width:0;visibility:hidden;pointer-events:none;';
    document.documentElement.appendChild(probe);
    var h = probe.getBoundingClientRect().height;
    document.documentElement.removeChild(probe);
    if (!(h > 0)) {
      h = window.innerHeight || document.documentElement.clientHeight || 1;
    }
    return Math.max(1, h);
  }

  function cachedViewportUnit(unit){
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    var cache = viewportUnitCache[unit];
    if (cache.px >= 1 && width === cache.width) {
      return cache.px;
    }
    cache.width = width;
    cache.px = measureViewportUnitPx(unit);
    return cache.px;
  }

  UTIL.svh = function(){
    return cachedViewportUnit('svh');
  };

  UTIL.lvh = function(){
    return cachedViewportUnit('lvh');
  };

  function invalidateViewportUnitCache(){
    viewportUnitCache.svh.px = 0;
    viewportUnitCache.svh.width = -1;
    viewportUnitCache.lvh.px = 0;
    viewportUnitCache.lvh.width = -1;
  }

  var layoutSettleMs = 180;
  var layoutSettleTimer = null;
  var layoutSettleListeners = [];

  function flushLayoutSettle(){
    layoutSettleTimer = null;
    invalidateViewportUnitCache();
    var i;
    for (i = 0; i < layoutSettleListeners.length; i++) {
      layoutSettleListeners[i]();
    }
    try {
      window.dispatchEvent(new CustomEvent('util:layoutsettle'));
    } catch (err) {}
  }

  function scheduleLayoutSettle(){
    if (layoutSettleTimer) {
      window.clearTimeout(layoutSettleTimer);
    }
    layoutSettleTimer = window.setTimeout(flushLayoutSettle, layoutSettleMs);
  }

  UTIL.onLayoutSettle = function(fn){
    if (typeof fn === 'function') {
      layoutSettleListeners.push(fn);
    }
  };

  window.addEventListener('resize', scheduleLayoutSettle);
  window.addEventListener('orientationchange', scheduleLayoutSettle);

  UTIL.isElementVisible = function(el, viewportHeight){
    var node = el && el.jquery ? el.get(0) : el;
    if (typeof node === 'string') {
      node = $(node).get(0);
    }
    if (!node || typeof node.getBoundingClientRect !== 'function') {
      return false;
    }
    var vh = viewportHeight || UTIL.svh();
    var rect = node.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < vh;
  };

  UTIL.hasFunctionByPath = function(path, rootObj){
    if (typeof path !== 'string') {
      return null;
    }
    var cleanPath = String(path).trim();
    if (!cleanPath) {
      return null;
    }

    var parts = cleanPath.split('.');
    var scope = rootObj || window;
    var i;
    for (i = 0; i < parts.length - 1; i++) {
      if (scope == null || typeof scope !== 'object') {
        return null;
      }
      scope = scope[parts[i]];
    }
    if (scope == null) {
      return null;
    }

    var methodName = parts[parts.length - 1];
    var fn = scope[methodName];
    if (typeof fn !== 'function') {
      return null;
    }

    return {
      context: scope,
      fn: fn
    };
  };

  UTIL.invokeFunctionByPath = function(path, args, rootObj){
    var ref = UTIL.hasFunctionByPath(path, rootObj);
    if (!ref) {
      return false;
    }
    ref.fn.apply(ref.context, Array.isArray(args) ? args : []);
    return true;
  };

  // Viewport splits for piped attribute values. Matches $screenS / $screenM / $screenXL.
  UTIL.attrBreakpointSmPx = 768;
  UTIL.attrBreakpointPx = 992;
  UTIL.attrBreakpointXlPx = 2400;

  function attrNode(el){
    if (!el) {
      return null;
    }
    return el.jquery ? el.get(0) : el;
  }

  function firstNonEmpty(parts){
    var i;
    for (i = 0; i < parts.length; i++) {
      if (parts[i] !== '') {
        return parts[i];
      }
    }
    return '';
  }

  // One value: all widths.
  // "a|b": <992 uses a, >=992 uses b.
  // "a|b|c": <768 uses a, 768–991 uses b, >=992 uses c.
  // "a|b|c|d": <768 uses a, 768–991 uses b, 992–2399 uses c, >=2400 uses d.
  UTIL.pickBreakpointValue = function(raw, widthPx){
    if (raw == null) {
      return null;
    }
    var parts = String(raw).split('|');
    var i;
    for (i = 0; i < parts.length; i++) {
      parts[i] = parts[i].trim();
    }
    var width = (widthPx != null) ? widthPx : (window.innerWidth || document.documentElement.clientWidth || 0);
    var chosen;
    if (parts.length >= 4) {
      if (width < UTIL.attrBreakpointSmPx) {
        chosen = parts[0];
      } else if (width < UTIL.attrBreakpointPx) {
        chosen = parts[1];
      } else if (width < UTIL.attrBreakpointXlPx) {
        chosen = parts[2];
      } else {
        chosen = parts[3];
      }
    } else if (parts.length === 3) {
      if (width < UTIL.attrBreakpointSmPx) {
        chosen = parts[0];
      } else if (width < UTIL.attrBreakpointPx) {
        chosen = parts[1];
      } else {
        chosen = parts[2];
      }
    } else if (parts.length === 2) {
      chosen = (width < UTIL.attrBreakpointPx) ? parts[0] : parts[1];
    } else {
      chosen = parts[0] || '';
    }
    if (chosen === '') {
      chosen = firstNonEmpty(parts);
    }
    return chosen;
  };

  UTIL.cssLengthToPx = function(raw, contextEl){
    if (raw == null) {
      return 0;
    }
    var s = String(raw).trim();
    if (!s) {
      return 0;
    }
    var sign = 1;
    if (s.charAt(0) === '-') {
      sign = -1;
      s = s.slice(1).trim();
    } else if (s.charAt(0) === '+') {
      s = s.slice(1).trim();
    }
    var n = parseFloat(s);
    if (!Number.isFinite(n)) {
      return 0;
    }
    var unit = s.replace(/^[+-]?[\d.]+/, '').trim().toLowerCase();
    var px = 0;
    var node = contextEl && contextEl.jquery ? contextEl[0] : contextEl;
    if (unit === '' || unit === 'px') {
      px = n;
    } else if (unit === 'rem') {
      px = n * (parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16);
    } else if (unit === 'em') {
      px = n * (parseFloat(window.getComputedStyle(node || document.documentElement).fontSize) || 16);
    } else if (unit === 'svh') {
      px = (n / 100) * UTIL.svh();
    } else if (unit === 'lvh') {
      px = (n / 100) * UTIL.lvh();
    } else if (unit === 'vh' || unit === 'dvh') {
      px = (n / 100) * UTIL.svh();
    } else if (unit === 'vw') {
      px = (n / 100) * (window.innerWidth || document.documentElement.clientWidth || 1);
    } else {
      px = n;
    }
    return sign * px;
  };

  function parseScaleExpression(raw, contextEl){
    var s = String(raw || '').trim();
    if (!s) {
      return null;
    }
    var clampMatch = s.match(/^clamp\(\s*([^,]+),\s*(.+),\s*([^)]+)\s*\)$/i);
    if (clampMatch) {
      var lo = parseScaleExpression(clampMatch[1], contextEl);
      var mid = parseScaleExpression(clampMatch[2], contextEl);
      var hi = parseScaleExpression(clampMatch[3], contextEl);
      if (lo == null || mid == null || hi == null) {
        return null;
      }
      return Math.min(hi, Math.max(lo, mid));
    }
    var divParts = s.split('/');
    if (divParts.length === 2) {
      var a = UTIL.cssLengthToPx(divParts[0], contextEl);
      var b = UTIL.cssLengthToPx(divParts[1], contextEl);
      if (!(b > 0)) {
        return null;
      }
      return a / b;
    }
    if (/^-?[\d.]+$/.test(s)) {
      var constant = parseFloat(s);
      return Number.isFinite(constant) ? constant : null;
    }
    var refPx = UTIL.cssLengthToPx(s, contextEl);
    if (refPx > 0) {
      return UTIL.svh() / refPx;
    }
    return null;
  }

  // Converts *vh scroll distances* to px, capped so tall screens do not
  // require a full extra viewport of drag. Does not change painted height.
  UTIL.scrollVh = function(contextEl){
    var svh = UTIL.svh();
    var node = attrNode(contextEl) || document.documentElement;
    var host = null;
    if (node && typeof node.closest === 'function') {
      host = node.closest('[data-scroll-vh-max]');
    }
    if (!host && document.documentElement && document.documentElement.hasAttribute('data-scroll-vh-max')) {
      host = document.documentElement;
    }
    if (!host && document.body && document.body.hasAttribute('data-scroll-vh-max')) {
      host = document.body;
    }
    var maxRaw = host ? UTIL.attr(host, 'data-scroll-vh-max') : '900px';
    if (maxRaw == null || String(maxRaw).trim() === '') {
      maxRaw = '900px';
    }
    var maxPx = UTIL.cssLengthToPx(maxRaw, node);
    if (!(maxPx > 0)) {
      maxPx = 900;
    }
    return Math.max(1, Math.min(svh, maxPx));
  };

  // Height-based multiplier for absolute scroll distances (px/rem/em/unitless).
  // Viewport units already follow window height and are left unscaled.
  // Override per element / ancestor / <html> with data-scroll-scale.
  // Examples: "1.2", "900px", "100svh / 900px", "clamp(0.85, 100svh / 900px, 2)", "1|1.1|1.5"
  UTIL.scrollScale = function(contextEl){
    var node = attrNode(contextEl) || document.documentElement;
    var host = null;
    if (node && typeof node.closest === 'function') {
      host = node.closest('[data-scroll-scale]');
    }
    if (!host && document.documentElement && document.documentElement.hasAttribute('data-scroll-scale')) {
      host = document.documentElement;
    }
    if (!host && document.body && document.body.hasAttribute('data-scroll-scale')) {
      host = document.body;
    }
    var raw = host ? UTIL.attr(host, 'data-scroll-scale') : null;
    var scale = parseScaleExpression(raw, node);
    if (scale == null) {
      scale = UTIL.scrollVh(node) / 900;
    }
    var minRaw = host ? UTIL.attr(host, 'data-scroll-scale-min') : null;
    var maxRaw = host ? UTIL.attr(host, 'data-scroll-scale-max') : null;
    var min = minRaw != null && minRaw !== '' ? parseFloat(minRaw) : 0.85;
    var max = maxRaw != null && maxRaw !== '' ? parseFloat(maxRaw) : 2;
    if (!Number.isFinite(min)) {
      min = 0.85;
    }
    if (!Number.isFinite(max)) {
      max = 2;
    }
    if (scale < min) {
      return min;
    }
    if (scale > max) {
      return max;
    }
    return scale;
  };

  function lengthUnit(raw){
    var s = String(raw || '').trim();
    if (s.charAt(0) === '-' || s.charAt(0) === '+') {
      s = s.slice(1).trim();
    }
    return s.replace(/^[+-]?[\d.]+/, '').trim().toLowerCase();
  }

  UTIL.scrollLengthPx = function(raw, contextEl){
    var px = UTIL.cssLengthToPx(raw, contextEl);
    var unit = lengthUnit(raw);
    var viewportRelative = (unit === 'svh' || unit === 'lvh' || unit === 'vh' || unit === 'dvh' || unit === 'vw');
    if (!viewportRelative) {
      px *= UTIL.scrollScale(contextEl);
    }
    return px;
  };

  // Length → vh for choreography. Viewport units follow the real screen.
  // px/rem/unitless are relative to a 900px design height so 80px of pause
  // is the same fraction of a screen on iPhone and iMac.
  UTIL.lengthToVh = function(raw, contextEl){
    if (raw == null || String(raw).trim() === '') {
      return 0;
    }
    var px = UTIL.cssLengthToPx(raw, contextEl);
    var unit = lengthUnit(raw);
    var svh = Math.max(1, UTIL.svh());
    var viewportRelative = (unit === 'svh' || unit === 'lvh' || unit === 'vh' || unit === 'dvh');
    if (viewportRelative) {
      return (px / svh) * 100;
    }
    return (px / 900) * 100;
  };

  UTIL.attr = function(el, attrName, widthPx){
    var node = attrNode(el);
    if (!node || typeof node.getAttribute !== 'function' || !node.hasAttribute(attrName)) {
      return null;
    }
    return UTIL.pickBreakpointValue(node.getAttribute(attrName), widthPx);
  };

  UTIL.attrNumber = function(el, attrName, fallback, widthPx){
    var str = UTIL.attr(el, attrName, widthPx);
    if (str == null || str === '') {
      return (fallback !== undefined) ? fallback : null;
    }
    var value = parseFloat(str);
    if (!Number.isFinite(value)) {
      return (fallback !== undefined) ? fallback : null;
    }
    return value;
  };

  UTIL.attrScrollLength = function(el, attrName, fallback, widthPx){
    var str = UTIL.attr(el, attrName, widthPx);
    if (str == null || str === '') {
      return (fallback !== undefined) ? fallback : null;
    }
    return UTIL.scrollLengthPx(str, el);
  };

  return UTIL;
})(window.UTIL || {}, jQuery, window, document);
